import React from "react";
import Icon, { type IconProps } from "./Icon";
/** Shield — Lucide. https://lucide.dev/icons/shield (MIT). Copied 2026-05-16.
 *  Phase 3d: AdminAudit state.full marker (admin override / full state replace). */
export default function Shield(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
    </Icon>
  );
}
